import React from 'react';
import { Button, Grid, ModalWindow, RadioList } from 'ui-toolkit';
import '../../scss/_RefiEligibilityModal.scss';
import WorkingWrapper from './WorkingWrapper';
import { DateTime } from 'luxon';
import { IRefiDiscount } from '../../ui-toolkit/orders/interfaces/IRefiDiscount';

interface IRefiEligibilityModalProps {
  loading: boolean;
  onSubmit: (refiDiscount: IRefiDiscount) => void;
  onClose: () => void;
  refiDiscount: IRefiDiscount;
  state?: string | null;
  refiConditionForState?: string | null;
}

interface IRefiEligibilityModalState {
  refiDiscount: IRefiDiscount;
}

export default class RefiEligibilityModal extends React.Component<
  IRefiEligibilityModalProps,
  IRefiEligibilityModalState
> {
  constructor(props: IRefiEligibilityModalProps) {
    super(props);
    this.state = {
      refiDiscount: props.refiDiscount,
    };
  }

  public render() {
    const { loading, onClose, refiConditionForState } = this.props;
    const { applied, finalized_at } = this.state.refiDiscount;
    const selectedOption = !!finalized_at ? (applied ? 'yes' : 'no') : undefined;
    return (
      <ModalWindow
        className="refi-eligibility-modal"
        uitype="medium"
        onClose={onClose}
        mode={loading ? 'transition' : 'default'}
      >
        <WorkingWrapper working={loading}>
          <div className="refi-eligibility-modal__content">
            <h3>Discount Eligibility</h3>
            <p>
              Does this order have <strong>{refiConditionForState || ''}</strong>?
            </p>
            <RadioList
              orientation="vertical"
              options={[
                {
                  label: (
                    <>
                      <div>Yes</div>
                      {selectedOption === 'yes' ? (
                        <div className="refi-eligibility-modal__hint">Fees will recalculate</div>
                      ) : null}
                    </>
                  ) as unknown as string,
                  value: 'yes',
                },
                {
                  label: (
                    <>
                      <div>No</div>
                      {selectedOption === 'no' ? (
                        <div className="refi-eligibility-modal__hint">Fees will not recalculate</div>
                      ) : null}
                    </>
                  ) as unknown as string,
                  value: 'no',
                },
              ]}
              name="eligibility"
              onChange={this.onChange}
              value={selectedOption}
            />
            <Grid columnCount={2} columnWidth={'max-content'}>
              <Button disabled={!selectedOption ? true : false} onClick={this.onSubmit} intent="primary">
                {applied ? 'Recalculate Fees' : 'Submit'}
              </Button>
              <Button intent="ghost" onClick={onClose}>
                Close
              </Button>
            </Grid>
          </div>
        </WorkingWrapper>
      </ModalWindow>
    );
  }

  public onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const applied = event.target.value === 'yes';
    this.setState(({ refiDiscount, ...rest }) => {
      return {
        ...rest,
        refiDiscount: {
          ...refiDiscount,
          applied,
          finalized_at: DateTime.fromJSDate(new Date()).toFormat("yyyy-MM-dd'T'HH:mm:ss"),
        },
      };
    });
  };
  public onSubmit = () => this.props.onSubmit(this.state.refiDiscount);
}
